export default __webpack_public_path__ + "static/media/intro3.9b3c388a.mp3";